import React from 'react';
import './HeadLine.css';

const HeadLine = ({text}) => {
    return (
        <div dangerouslySetInnerHTML={{__html: text.replace(/&nbsp;/g, ' ')}} className={"Headline"}></div>
    );
};

export default HeadLine;
